import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const WorkManagementIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "19",
        viewBox: "0 0 20 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9.57439 12.1966C10.815 12.1966 11.8207 11.1909 11.8207 9.95037C11.8207 8.70979 10.815 7.7041 9.57439 7.7041C8.33381 7.7041 7.32812 8.70979 7.32812 9.95037C7.32812 11.1909 8.33381 12.1966 9.57439 12.1966Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.57439 4.49253C10.815 4.49253 11.8207 3.48685 11.8207 2.24627C11.8207 1.00569 10.815 0 9.57439 0C8.33381 0 7.32812 1.00569 7.32812 2.24627C7.32812 3.48685 8.33381 4.49253 9.57439 4.49253Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.24627 9.81675C3.48685 9.81675 4.49253 8.81106 4.49253 7.57049C4.49253 6.32991 3.48685 5.32422 2.24627 5.32422C1.00569 5.32422 0 6.32991 0 7.57049C0 8.81106 1.00569 9.81675 2.24627 9.81675Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.0451 18.43C6.28567 18.43 7.29136 17.4243 7.29136 16.1838C7.29136 14.9432 6.28567 13.9375 5.0451 13.9375C3.80452 13.9375 2.79883 14.9432 2.79883 16.1838C2.79883 17.4243 3.80452 18.43 5.0451 18.43Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.1017 18.431C15.3423 18.431 16.348 17.4253 16.348 16.1847C16.348 14.9442 15.3423 13.9385 14.1017 13.9385C12.8612 13.9385 11.8555 14.9442 11.8555 16.1847C11.8555 17.4253 12.8612 18.431 14.1017 18.431Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.9025 9.81675C18.1431 9.81675 19.1488 8.81106 19.1488 7.57049C19.1488 6.32991 18.1431 5.32422 16.9025 5.32422C15.6619 5.32422 14.6562 6.32991 14.6562 7.57049C14.6562 8.81106 15.6619 9.81675 16.9025 9.81675Z",
                fill: "white"
            })
        ]
    });
export default WorkManagementIcon;
